<div class="breadcrumb-container container">
  <p-breadcrumb [model]="items" [home]="home" />
</div>

<!-- ════════════════ WIZARD HEADER ════════════════ -->
<div class="wizard-header">
  <div class="container wh-inner">
    <div class="wh-title-row">
      <div>
        <h1 class="wh-title">{{ IsEditMode ? 'Editar Rascunho da Campanha' : 'Criar Nova Campanha' }}</h1>
        <p class="wh-subtitle">Preencha os passos abaixo para publicar a sua campanha de angariação no FundCube.</p>
      </div>
      <div class="wh-meta-group">
        <div class="wh-completion-badge" [class.complete]="isFormularioCompleto()">
          <div class="wh-completion-header">
            <span class="wh-completion-title">
              <i class="fa-solid" [ngClass]="isFormularioCompleto() ? 'fa-circle-check' : 'fa-list-check'"></i>
              Preenchimento
            </span>
            <span class="wh-completion-pct">{{ getPercentualPreenchimento() }}%</span>
          </div>
          <div class="wh-completion-bar">
            <div class="wh-completion-fill" [style.width.%]="getPercentualPreenchimento()"
              [class.complete]="isFormularioCompleto()"></div>
          </div>
        </div>

        <div class="wh-step-badge">
          Passo <strong>{{ step }}</strong> de 3
        </div>
      </div>
    </div>

    <div class="step-progress" role="list" aria-label="Progresso do formulário">
      <div class="step-item" (click)="goToStep(1)">
        <div class="step-circle" [ngClass]="{ active: step === 1, completed: step > 1, pending: step < 1 }">
          <i class="fa-solid fa-check" *ngIf="step > 1"></i>
          <span *ngIf="step <= 1">1</span>
        </div>
        <div class="step-info">
          <span class="step-name" [ngClass]="{ active: step === 1, pending: step < 1 }">Tipo e Categorias</span>
          <span class="step-desc">Modelo e localização</span>
        </div>
      </div>

      <div class="step-connector" [ngClass]="{ done: step > 1 }"></div>

      <div class="step-item" (click)="goToStep(2)">
        <div class="step-circle" [ngClass]="{ active: step === 2, completed: step > 2, pending: step < 2 }">
          <i class="fa-solid fa-check" *ngIf="step > 2"></i>
          <span *ngIf="step <= 2">2</span>
        </div>
        <div class="step-info">
          <span class="step-name" [ngClass]="{ active: step === 2, pending: step < 2 }">História e Média</span>
          <span class="step-desc">Narrativa, fotos e vídeo</span>
        </div>
      </div>

      <div class="step-connector" [ngClass]="{ done: step > 2 }"></div>

      <div class="step-item" (click)="goToStep(3)">
        <div class="step-circle" [ngClass]="{ active: step === 3, pending: step < 3 }">
          <span>3</span>
        </div>
        <div class="step-info">
          <span class="step-name" [ngClass]="{ active: step === 3, pending: step < 3 }">Metas e Prazos</span>
          <span class="step-desc">Objectivo, IBAN e prazo</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ════════════════ WIZARD LAYOUT ════════════════ -->
<div class="container wizard-layout">
  <main>
    <form [formGroup]="campanhaForm" class="wizard-form">

      <!-- ═══════════════════════════════════════
           PASSO 1: TIPO & CATEGORIAS
      ═══════════════════════════════════════ -->
      <section class="wizard-step-content" *ngIf="step === 1">
        <div class="step-card">
          <div class="step-card-header">
            <div class="step-icon"><i class="fa-solid fa-layer-group"></i></div>
            <div>
              <h2 class="step-card-title">Modelo de Financiamento</h2>
              <p class="step-card-subtitle">Seleccione a modalidade que melhor atende às necessidades do seu projecto.
              </p>
            </div>
          </div>

          <div class="step-card-body">
            <!-- Selector de Tipo em Cards -->
            <div class="form-group">
              <label class="form-label">
                Tipo de Financiamento <span class="required">*</span>
              </label>

              <div class="campaign-type-grid" [class.single-card]="TipoFinanciamento.length === 1" role="group"
                aria-label="Tipo de campanha" *ngIf="tiposCarregados">
                <!-- Doação -->
                <div class="type-card type-doacao" *ngIf="isTipoAtivo(1)"
                  [class.active]="campanhaForm.get('tipoFinanciamentoENUM')?.value === 1"
                  (click)="selectTipoFinanciamento(1)">
                  <div class="type-check"><i class="fa-solid fa-check"></i></div>
                  <div class="type-icon-wrap">
                    <i class="fa-solid fa-hand-holding-heart"></i>
                  </div>
                  <h3 class="type-name">Doação</h3>
                  <p class="type-tagline">
                    Contribuições voluntárias sem contrapartida financeira. Ideal para causas sociais, comunitárias e
                    ambientais.
                  </p>
                  <div class="type-features">
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Sem obrigação de
                        reembolso</span></div>
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Apoio directo à
                        comunidade</span></div>
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Contribuições livres</span>
                    </div>
                  </div>
                </div>

                <!-- Empréstimo -->
                <div class="type-card type-emprestimo" *ngIf="isTipoAtivo(2)"
                  [class.active]="campanhaForm.get('tipoFinanciamentoENUM')?.value === 2"
                  (click)="selectTipoFinanciamento(2)">
                  <div class="type-check"><i class="fa-solid fa-check"></i></div>
                  <div class="type-icon-wrap">
                    <i class="fa-solid fa-handshake-angle"></i>
                  </div>
                  <h3 class="type-name">Empréstimo</h3>
                  <p class="type-tagline">
                    Financiamento colectivo reembolsável aos investidores, com parcelas e taxa de juro acordadas.
                  </p>
                  <div class="type-features">
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Reembolso parcelado</span>
                    </div>
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Taxa de juro
                        parametrizada</span></div>
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Para negócios e
                        produção</span></div>
                  </div>
                </div>

                <!-- Recompensa -->
                <div class="type-card type-recompensa" *ngIf="isTipoAtivo(3)"
                  [class.active]="campanhaForm.get('tipoFinanciamentoENUM')?.value === 3"
                  (click)="selectTipoFinanciamento(3)">
                  <div class="type-check"><i class="fa-solid fa-check"></i></div>
                  <div class="type-icon-wrap">
                    <i class="fa-solid fa-gift"></i>
                  </div>
                  <h3 class="type-name">Recompensa</h3>
                  <p class="type-tagline">
                    Os apoiadores recebem contrapartidas, produtos exclusivos ou serviços em troca da sua contribuição.
                  </p>
                  <div class="type-features">
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Até 3 níveis de
                        recompensa</span></div>
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Produtos ou serviços
                        exclusivos</span></div>
                    <div class="type-feat"><i class="fa-solid fa-circle-check"></i> <span>Para criadores e
                        startups</span></div>
                  </div>
                </div>
              </div>

              <!-- Indicador de carregamento enquanto busca tipos do back -->
              <div class="campaign-type-grid" *ngIf="!tiposCarregados">
                <div class="type-card" style="opacity: 0.7; pointer-events: none;">
                  <div class="type-icon-wrap" style="background: var(--gray-100); color: var(--gray-500);">
                    <i class="fa-solid fa-spinner fa-spin"></i>
                  </div>
                  <h3 class="type-name" style="color: var(--gray-600);">A carregar modalidades...</h3>
                  <p class="type-tagline">A carregar as opções de financiamento disponíveis no sistema.</p>
                </div>
              </div>

              <small class="field-error" *ngIf="isInvalid('tipoFinanciamentoENUM')">
                <i class="fa-solid fa-triangle-exclamation"></i> O tipo de financiamento é obrigatório.
              </small>
            </div>

            <!-- Detalhes do Empréstimo (se tipo === 2) -->
            <div class="sub-section-box emprestimo-box" *ngIf="campanhaForm.get('tipoFinanciamentoENUM')?.value === 2">
              <div class="sub-section-header">
                <i class="fa-solid fa-calculator"></i>
                <div>
                  <h4 class="sub-section-title">Parâmetros do Empréstimo</h4>
                  <p class="sub-section-desc">Defina o montante solicitado, prazo e condições de reembolso.</p>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label" for="ValorSolicitado">Valor Solicitado (Kz) <span
                      class="required">*</span></label>
                  <div class="input-with-icon">
                    <i class="fa-solid fa-money-bill-wave input-icon"></i>
                    <input type="text" pInputText formControlName="ValorSolicitado" id="ValorSolicitado"
                      placeholder="Ex: 5.000.000,00" class="form-input" [class.error]="isInvalid('ValorSolicitado')" />
                  </div>
                  <small class="field-error" *ngIf="isInvalid('ValorSolicitado')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Valor do empréstimo é obrigatório.
                  </small>
                </div>

                <div class="form-group">
                  <label class="form-label" for="QuantidadeParcelas">Quantidade de Parcelas <span
                      class="required">*</span></label>
                  <p-select formControlName="QuantidadeParcelas" id="QuantidadeParcelas"
                    [options]="quantidadeQuantidadeParcelas" optionLabel="label" optionValue="id"
                    placeholder="Seleccione o número de parcelas" class="w-full" appendTo="body"
                    [invalid]="isInvalid('QuantidadeParcelas')" />
                  <small class="field-error" *ngIf="isInvalid('QuantidadeParcelas')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Número de parcelas é obrigatório.
                  </small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label" for="PercentualJuros">Taxa de Juro (%) <span
                      class="required">*</span></label>
                  <p-select formControlName="PercentualJuros" id="PercentualJuros" [options]="jurosList"
                    optionLabel="label" optionValue="id" placeholder="Seleccione a percentagem de juros" class="w-full"
                    appendTo="body" [invalid]="isInvalid('PercentualJuros')" />
                  <small class="field-error" *ngIf="isInvalid('PercentualJuros')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Percentagem de juros é obrigatória.
                  </small>
                </div>

                <div class="form-group">
                  <label class="form-label" for="PeriodoReembolsoMeses">Período de Reembolso (Meses) <span
                      class="required">*</span></label>
                  <p-select formControlName="PeriodoReembolsoMeses" id="PeriodoReembolsoMeses"
                    [options]="PeriodoReembolsoMesesList" optionLabel="label" optionValue="id"
                    placeholder="Seleccione o período em meses" class="w-full" appendTo="body"
                    [invalid]="isInvalid('PeriodoReembolsoMeses')" />
                  <small class="field-error" *ngIf="isInvalid('PeriodoReembolsoMeses')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Período de pagamento é obrigatório.
                  </small>
                </div>
              </div>
            </div>

            <!-- Construtor de Recompensas (se tipo === 3) -->
            <div class="sub-section-box recompensa-box" *ngIf="campanhaForm.get('tipoFinanciamentoENUM')?.value === 3"
              [formGroup]="recompensaForm">
              <div class="sub-section-header">
                <i class="fa-solid fa-gift"></i>
                <div class="w-full">
                  <div class="flex items-center justify-between flex-wrap gap-2">
                    <h4 class="sub-section-title">Adicionar Recompensas (Máx. 15)</h4>
                    <span class="text-xs text-amber-700 bg-amber-100 px-2.5 py-1 rounded-full font-medium"
                      *ngIf="carregandoParametrosRecompensa">
                      <i class="fa-solid fa-spinner fa-spin"></i> A carregar parâmetros da API...
                    </span>
                  </div>
                  <p class="sub-section-desc">
                    Crie incentivos atraentes para quem apoiar o seu projecto.
                  </p>

                  <!-- Painel de Parâmetros Oficiais da API FundCube -->
                  <div class="recompensa-parametros-banner" *ngIf="parametrosRecompensaBackend?.length">
                    <div class="rpb-header">
                      <i class="fa-solid fa-sliders"></i>
                      <span>Parâmetros de Financiamento por Recompensa</span>
                    </div>
                    <div class="rpb-chips">
                      <div class="rpb-chip" *ngIf="limiteMinimoRecompensa && limiteMaximoRecompensa">
                        <span class="rpb-chip-label">Valor por Recompensa:</span>
                        <span class="rpb-chip-value highlight">
                          {{ limiteMinimoRecompensa | money }} Kz a {{ limiteMaximoRecompensa | money }} Kz
                        </span>
                      </div>
                      <div class="rpb-chip" *ngIf="recompensaComissao !== null">
                        <span class="rpb-chip-label">Comissão da Campanha:</span>
                        <span class="rpb-chip-value">{{ recompensaComissao }}%</span>
                      </div>
                      <div class="rpb-chip" *ngIf="recompensaTaxaServico !== null">
                        <span class="rpb-chip-label">Taxa de Serviço:</span>
                        <span class="rpb-chip-value">{{ recompensaTaxaServico }}%</span>
                      </div>
                      <div class="rpb-chip" *ngIf="recompensaDuracaoMinima && recompensaDuracaoMaxima">
                        <span class="rpb-chip-label">Duração Permitida:</span>
                        <span class="rpb-chip-value">{{ recompensaDuracaoMinima }} a {{ recompensaDuracaoMaxima }}
                          dias</span>
                      </div>
                      <div class="rpb-chip" *ngIf="recompensaCampanhaSucesso !== null">
                        <span class="rpb-chip-label">Meta Mínima Sucesso:</span>
                        <span class="rpb-chip-value">{{ recompensaCampanhaSucesso }}%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Tipo de Recompensa <span class="required">*</span></label>
                  <p-select formControlName="TipoRecompensaENUM" [options]="TipoRecompensaENUMList" optionLabel="label"
                    optionValue="id" placeholder="Seleccione o tipo" class="w-full" appendTo="body"
                    [invalid]="isInvalidRecompensa('TipoRecompensaENUM')" />
                  <small class="field-error" *ngIf="isInvalidRecompensa('TipoRecompensaENUM')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Tipo de recompensa é obrigatório.
                  </small>
                </div>

                <div class="form-group">
                  <label class="form-label">Título da Recompensa <span class="required">*</span></label>
                  <input type="text" pInputText formControlName="Titulo" placeholder="Ex: Kit Especial + Agradecimento"
                    class="form-input" [class.error]="isInvalidRecompensa('Titulo')" />
                  <small class="field-error" *ngIf="isInvalidRecompensa('Titulo')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Título é obrigatório.
                  </small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">
                    Valor de Apoio (Kz) <span class="required">*</span>
                    <span class="text-xs font-normal" style="color: #6b7280;" *ngIf="limiteMinimoRecompensa">
                      (Mínimo: {{ limiteMinimoRecompensa | number }} Kz)
                    </span>
                  </label>
                  <input type="number" [min]="limiteMinimoRecompensa" pInputText formControlName="Valor"
                    [placeholder]="'Mínimo ' + (limiteMinimoRecompensa | number) + ' Kz'" class="form-input"
                    [class.error]="isInvalidRecompensa('Valor')" />
                  <small class="field-error" *ngIf="isInvalidRecompensa('Valor')">
                    <i class="fa-solid fa-triangle-exclamation"></i> O valor deve ser de pelo menos {{
                    limiteMinimoRecompensa
                    | number }} Kz.
                  </small>
                </div>

                <div class="form-group">
                  <label class="form-label">Quantidade Disponível <span class="required">*</span></label>
                  <input type="number" min="1" pInputText formControlName="Quantidade" placeholder="Ex: 50"
                    class="form-input" [class.error]="isInvalidRecompensa('Quantidade')" />
                  <small class="field-error" *ngIf="isInvalidRecompensa('Quantidade')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Quantidade é obrigatória.
                  </small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Data de Início da Recompensa <span class="required">*</span></label>
                  <p-datePicker formControlName="DataInicioRecompensa" class="w-full" appendTo="body"
                    [minDate]="getDataTerminoCampanha() || hoje"
                    [invalid]="isInvalidRecompensa('DataInicioRecompensa')" />
                  <small class="field-error" *ngIf="isInvalidRecompensa('DataInicioRecompensa')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Data de início deve ser posterior ao término da campanha.
                  </small>
                  <span class="form-hint" *ngIf="getDataTerminoCampanha()">
                    <i class="fa-solid fa-circle-info"></i> A campanha terminará em <strong>{{ getDataTerminoCampanha() | date: 'dd/MM/yyyy' }}</strong>. As recompensas são liberadas a partir do término da campanha.
                  </span>
                </div>

                <div class="form-group">
                  <label class="form-label">Data de Término da Recompensa <span class="required">*</span></label>
                  <p-datePicker formControlName="DataTerminoRecompensa" class="w-full" appendTo="body"
                    [minDate]="recompensaForm.get('DataInicioRecompensa')?.value || getDataTerminoCampanha() || hoje"
                    [invalid]="isInvalidRecompensa('DataTerminoRecompensa')" />
                  <small class="field-error" *ngIf="isInvalidRecompensa('DataTerminoRecompensa')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Data de término deve ser posterior ao início da recompensa.
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">Descrição da Recompensa <span class="required">*</span></label>
                <textarea pTextarea rows="3" formControlName="Descricao"
                  placeholder="Detalhes sobre o que o apoiador irá receber..." class="form-textarea"
                  [class.error]="isInvalidRecompensa('Descricao')"></textarea>
                <small class="field-error" *ngIf="isInvalidRecompensa('Descricao')">
                  <i class="fa-solid fa-triangle-exclamation"></i> Descrição da recompensa é obrigatória.
                </small>
              </div>

              <div class="flex justify-content-end gap-2">
                <button *ngIf="editIndex !== null" type="button" class="btn btn-secondary btn-sm"
                  (click)="cancelarEdicaoRecompensa()">
                  <i class="fa-solid fa-xmark"></i> Cancelar Edição
                </button>
                <button type="button" class="btn btn-primary btn-sm" (click)="addRecompensa()">
                  <i class="fa-solid" [ngClass]="editIndex !== null ? 'fa-check' : 'fa-plus'"></i>
                  {{ editIndex !== null ? 'Atualizar Recompensa' : 'Adicionar Recompensa' }}
                </button>
              </div>

              <!-- Lista de Recompensas Adicionadas -->
              <div class="recompensas-list-container" *ngIf="recompensas.length > 0">
                <h5 class="recompensas-list-title">Recompensas Registadas ({{ recompensas.length }}/{{ maxRecompensas
                  }}):</h5>
                <div class="recompensa-item-card" *ngFor="let recompensa of recompensas.controls; let i = index">
                  <div class="ric-left">
                    <span class="ric-badge">#{{ i + 1 }}</span>
                    <div>
                      <div class="ric-title">{{ recompensa.value.Titulo }}</div>
                      <div class="ric-meta">
                        <span><strong>{{ recompensa.value.Valor | money }} Kz</strong></span> &bull;
                        <span>Qtd: <strong>{{ recompensa.value.Quantidade }}</strong></span> &bull;
                        <span>Subtotal: <strong>{{ getSubtotalRecompensa(recompensa) | money }} Kz</strong></span>
                        &bull;
                        <span>{{ recompensa.value.DataInicioRecompensa | date: "dd/MM/yyyy" }} até {{
                          recompensa.value.DataTerminoRecompensa | date: "dd/MM/yyyy" }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="ric-actions">
                    <button type="button" class="btn-icon" title="Editar" (click)="editRecompensa(i)">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button type="button" class="btn-icon danger" title="Remover" (click)="removeRecompensa(i)">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>

                <!-- Resumo e Cálculo Automático da Meta da Campanha com base nas Recompensas -->
                <div class="recompensas-meta-resumo">
                  <div class="rmr-header">
                    <div class="rmr-header-title">
                      <i class="fa-solid fa-calculator"></i>
                      <span>Meta da Campanha Calculada</span>
                    </div>
                    <span class="rmr-badge">Taxa da Plataforma: {{ comissaoPorCampanha }}%</span>
                  </div>
                  <div class="rmr-body">
                    <div class="rmr-item">
                      <span class="rmr-label">Soma das Recompensas (Valor × Qtd)</span>
                      <span class="rmr-value">{{ getSomaRecompensas() | money }} Kz</span>
                      <span class="rmr-desc">{{ recompensas.length }} {{ recompensas.length === 1 ? 'recompensa
                        registada' : 'recompensas registadas' }}</span>
                    </div>
                    <div class="rmr-op">+</div>
                    <div class="rmr-item">
                      <span class="rmr-label">Comissão da Campanha ({{ comissaoPorCampanha }}%)</span>
                      <span class="rmr-value">{{ comissao | money }} Kz</span>
                      <span class="rmr-desc">Taxa de intermediação</span>
                    </div>
                    <div class="rmr-op">=</div>
                    <div class="rmr-item highlight">
                      <span class="rmr-label">Meta Total da Campanha</span>
                      <span class="rmr-value">{{ meta | money }} Kz</span>
                      <span class="rmr-desc">Valor da campanha</span>
                    </div>
                  </div>
                  <div class="rmr-footer">
                    <i class="fa-solid fa-circle-check"></i>
                    <span>Em campanhas de recompensa, o valor da campanha é calculado multiplicando o valor de cada
                      recompensa pela sua quantidade, somando todas elas e adicionando a comissão da plataforma.</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Divider: Categoria & Província -->
            <div class="form-section-divider">
              <span class="form-section-label">Categorização e Localização</span>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label class="form-label" for="CategoriaID">
                  Categoria do Projecto <span class="required">*</span>
                </label>
                <p-select formControlName="CategoriaID" [options]="categoriaOptions" optionLabel="label"
                  optionValue="id" placeholder="Seleccione a categoria" class="w-full" filter="true" showClear="true"
                  appendTo="body" [invalid]="isInvalid('CategoriaID')" />
                <small class="field-error" *ngIf="isInvalid('CategoriaID')">
                  <i class="fa-solid fa-triangle-exclamation"></i> A categoria é obrigatória.
                </small>
              </div>

              <div class="form-group">
                <label class="form-label" for="ProvinciaID">
                  Província <span class="required">*</span>
                </label>
                <p-select formControlName="ProvinciaID" [options]="provinciasOptions" optionLabel="label"
                  optionValue="id" placeholder="Seleccione a província" class="w-full" filter="true" showClear="true"
                  appendTo="body" [invalid]="isInvalid('ProvinciaID')" />
                <small class="field-error" *ngIf="isInvalid('ProvinciaID')">
                  <i class="fa-solid fa-triangle-exclamation"></i> A província é obrigatória.
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ═══════════════════════════════════════
           PASSO 2: HISTÓRIA & MÉDIA
      ═══════════════════════════════════════ -->
      <section class="wizard-step-content" *ngIf="step === 2">
        <div class="step-card">
          <div class="step-card-header">
            <div class="step-icon"><i class="fa-solid fa-pen-nib"></i></div>
            <div>
              <h2 class="step-card-title">História & Média do Projecto</h2>
              <p class="step-card-subtitle">Apresente a sua visão de forma envolvente e profissional para inspirar
                confiança.</p>
            </div>
          </div>

          <div class="step-card-body">
            <!-- Título -->
            <div class="form-group">
              <label class="form-label" for="titulo">
                Título da Campanha <span class="required">*</span>
              </label>
              <div class="input-with-icon">
                <i class="fa-solid fa-heading input-icon"></i>
                <input type="text" pInputText formControlName="titulo" id="titulo"
                  placeholder="Ex: Aquisição de Painéis Solares para Cooperativa de Malanje" class="form-input"
                  [class.error]="isInvalid('titulo')" />
              </div>
              <span class="form-hint">Seja claro, conciso e impactante. Máximo recomendado: 80 caracteres.</span>
              <small class="field-error" *ngIf="isInvalid('titulo')">
                <i class="fa-solid fa-triangle-exclamation"></i> Título da campanha é obrigatório.
              </small>
            </div>

            <!-- Resumo Curto -->
            <div class="form-group">
              <label class="form-label" for="descricaoCurta">
                Resumo Curto (Lead) <span class="required">*</span>
              </label>
              <textarea rows="3" pTextarea formControlName="descricaoCurta" id="descricaoCurta"
                placeholder="Escreva uma frase marcante resumindo a essência e o objectivo principal da campanha..."
                class="form-textarea" [class.error]="isInvalid('descricaoCurta')"></textarea>
              <div class="char-count" [class.warn]="(campanhaForm.get('descricaoCurta')?.value?.length || 0) > 160">
                {{ campanhaForm.get('descricaoCurta')?.value?.length || 0 }} / 180 caracteres
              </div>
              <small class="field-error" *ngIf="isInvalid('descricaoCurta')">
                <i class="fa-solid fa-triangle-exclamation"></i> Resumo é obrigatório (máximo 180 caracteres).
              </small>
            </div>

            <!-- História Completa (Editor) -->
            <div class="form-group">
              <label class="form-label" for="descricao">
                História e Descrição Detalhada <span class="required">*</span>
              </label>
              <p-editor formControlName="descricao" [style]="{ height: '240px' }"
                placeholder="Conte detalhadamente o problema que aborda, a sua equipa, o impacto esperado e o plano de aplicação dos fundos..."
                class="w-full" [invalid]="isInvalid('descricao')">
              </p-editor>
              <small class="field-error" *ngIf="isInvalid('descricao')">
                <i class="fa-solid fa-triangle-exclamation"></i> A história completa é obrigatória.
              </small>
            </div>

            <!-- Divider: Multimédia -->
            <div class="form-section-divider">
              <span class="form-section-label">Material Multimédia</span>
            </div>

            <!-- Capa do Projecto -->
            <div class="form-group">
              <label class="form-label">
                Foto de Capa do Projecto <span class="required">*</span>
              </label>

              <!-- Dropzone ou preview -->
              <div class="upload-zone" [class.has-file]="selectedFile || imgPreview">
                <input id="capa-upload" type="file" accept=".png,.jpg,.jpeg" (change)="onFileSelected($event)" />

                <div class="upload-preview-state" *ngIf="selectedFile || imgPreview">
                  <div class="ups-thumb" *ngIf="selectedFilePreviewUrl || imgPreview">
                    <img [src]="selectedFilePreviewUrl || imgPreview" alt="Capa" />
                  </div>
                  <div class="ups-info">
                    <div class="ups-name">{{ selectedFile ? selectedFile.name : (imgInfo?.nome || 'Imagem de Capa') }}
                    </div>
                    <div class="ups-size">{{ selectedFile ? ((selectedFile.size / 1024) | number: '1.0-1') + ' KB' :
                      (imgInfo?.tamanho || '') }}</div>
                    <span class="upload-badge"><i class="fa-solid fa-check"></i> Ficheiro pronto</span>
                  </div>
                  <button type="button" class="btn-icon danger" title="Remover ficheiro"
                    (click)="$event.stopPropagation(); removeFile()">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>

                <div class="upload-empty-state" *ngIf="!selectedFile && !imgPreview">
                  <div class="upload-icon"><i class="fa-solid fa-cloud-arrow-up"></i></div>
                  <div class="upload-text">Arraste a foto da capa ou clique para seleccionar</div>
                  <div class="upload-hint">Formatos suportados: JPG, JPEG ou PNG (máx. 5MB). Resolução recomendada:
                    1200x675 px.</div>
                </div>
              </div>
              <small class="field-error" *ngIf="isInvalid('capaProjeto')">
                <i class="fa-solid fa-triangle-exclamation"></i> A foto de capa é obrigatória.
              </small>
            </div>

            <!-- Vídeo do Projecto -->
            <div class="form-group">
              <label class="form-label">Vídeo de Apresentação (Ficheiro Local)</label>
              <div class="upload-zone" [class.has-file]="selectedVideo || vidPreview">
                <input id="video-upload" type="file" accept=".mp4,.mpeg,.mov" (change)="onVideoSelected($event)" />

                <div class="upload-preview-state" *ngIf="selectedVideo || vidPreview">
                  <div class="ups-icon"><i class="fa-solid fa-video"></i></div>
                  <div class="ups-info">
                    <div class="ups-name">{{ selectedVideo ? selectedVideo.name : (VidInfo?.nome || 'Vídeo do Projecto')
                      }}</div>
                    <div class="ups-size">{{ selectedVideo ? ((selectedVideo.size / (1024 * 1024)) | number: '1.0-1') +
                      ' MB' : (VidInfo?.tamanho || '') }}</div>
                    <span class="upload-badge"><i class="fa-solid fa-check"></i> Vídeo anexado</span>
                  </div>
                  <button type="button" class="btn-icon danger" title="Remover vídeo"
                    (click)="$event.stopPropagation(); removeVideo()">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>

                <div class="upload-empty-state" *ngIf="!selectedVideo && !vidPreview">
                  <div class="upload-icon"><i class="fa-solid fa-film"></i></div>
                  <div class="upload-text">Arraste o vídeo da campanha ou clique para seleccionar</div>
                  <div class="upload-hint">Formatos: MP4, MPEG ou MOV (máx. 40MB). Ideal: 2 a 3 minutos.</div>
                </div>
              </div>
              <small class="field-error" *ngIf="isInvalid('videoProjeto')">
                <i class="fa-solid fa-triangle-exclamation"></i> Vídeo ou link do vídeo é obrigatório.
              </small>
            </div>

            <!-- Ou Link do Vídeo (YouTube/Vimeo) -->
            <div class="form-group">
              <label class="form-label" for="linkVideo">Ou Link de Vídeo (YouTube / Vimeo)</label>
              <div class="input-with-icon">
                <i class="fa-brands fa-youtube input-icon"></i>
                <input type="text" pInputText formControlName="linkVideo" id="linkVideo"
                  placeholder="https://www.youtube.com/watch?v=..." class="form-input" />
              </div>
              <span class="form-hint">Se preferir não carregar ficheiro MP4, insira o link de visualização
                directa.</span>
            </div>
          </div>
        </div>
      </section>

      <!-- ═══════════════════════════════════════
           PASSO 3: METAS, IBAN & PRAZOS
      ═══════════════════════════════════════ -->
      <section class="wizard-step-content" *ngIf="step === 3">
        <div class="step-card">
          <div class="step-card-header">
            <div class="step-icon"><i class="fa-solid fa-bullseye"></i></div>
            <div>
              <h2 class="step-card-title">Metas, Prazo & Dados Bancários</h2>
              <p class="step-card-subtitle">Configure os aspectos financeiros e garanta a conformidade para a
                liquidação.</p>
            </div>
          </div>

          <div class="step-card-body">
            <!-- Meta de Angariação -->
            <div class="form-group">
              <label class="form-label" for="MetaArrecadar">
                {{ campanhaForm.get('tipoFinanciamentoENUM')?.value === 3 ? 'Soma dos Valores das Recompensas (Valor ×
                Qtd) (Kz)' :
                'Objectivo Líquido Pretendido (Kz)' }} <span class="required">*</span>
              </label>
              <div class="input-with-icon">
                <span class="input-prefix-tag">Kz</span>
                <input type="number" pInputText formControlName="MetaArrecadar" id="MetaArrecadar"
                  [readOnly]="campanhaForm.get('tipoFinanciamentoENUM')?.value === 3" placeholder="Ex: 5000000"
                  class="form-input" [class.error]="isInvalid('MetaArrecadar')" />
              </div>

              <!-- Aviso para tipo Recompensa -->
              <div class="recompensa-meta-notice" *ngIf="campanhaForm.get('tipoFinanciamentoENUM')?.value === 3">
                <i class="fa-solid fa-circle-info"></i>
                <div class="rmn-text">
                  <div class="rmn-title">Meta calculada automaticamente por Recompensas</div>
                  <div>
                    Soma das recompensas (<strong>{{ getSomaRecompensas() | money }} Kz</strong>) + Taxa da plataforma
                    de {{ comissaoPorCampanha }}% (<strong>{{ comissao | money }} Kz</strong>) = <strong>Meta da
                      Campanha: {{ meta | money }} Kz</strong>.
                  </div>
                  <span class="block text-xs mt-1 text-slate-500" *ngIf="recompensas.length > 0">
                    Para alterar o valor da meta da campanha, adicione ou edite os valores ou quantidades das
                    recompensas no Passo 1.
                  </span>
                  <span class="block text-xs mt-1 text-amber-700 font-semibold" *ngIf="recompensas.length === 0">
                    <i class="fa-solid fa-triangle-exclamation"></i> Nenhuma recompensa registada ainda. Por favor,
                    volte ao Passo 1 e adicione pelo menos uma recompensa.
                  </span>
                </div>
              </div>

              <small class="field-error"
                *ngIf="isInvalid('MetaArrecadar') && campanhaForm.get('tipoFinanciamentoENUM')?.value !== 3">
                <i class="fa-solid fa-triangle-exclamation"></i> Meta pretendida é obrigatória e deve ser superior a
                zero.
              </small>
            </div>

            <!-- Calculadora Visual de Comissão -->
            <div class="fee-calculator show" *ngIf="(campanhaForm.get('MetaArrecadar')?.value || 0) > 0">
              <div class="fee-calc-header">
                <i class="fa-solid fa-calculator"></i>
                <span>{{ campanhaForm.get('tipoFinanciamentoENUM')?.value === 3 ? 'Detalhamento do Valor da Campanha' :
                  'Cálculo Transparente de Angariação' }}</span>
                <span class="fee-calc-badge">Taxa {{ comissaoPorCampanha }}%</span>
              </div>
              <div class="fee-calc-body">
                <div class="fee-calc-item">
                  <div class="fee-calc-label">{{ campanhaForm.get('tipoFinanciamentoENUM')?.value === 3 ? 'Soma das
                    Recompensas' : 'Objectivo Líquido' }}</div>
                  <div class="fee-calc-value v-objective">{{ campanhaForm.get('MetaArrecadar')?.value | money }} Kz
                  </div>
                  <div class="fee-calc-sub">{{ campanhaForm.get('tipoFinanciamentoENUM')?.value === 3 ? 'Total das
                    recompensas (Valor × Qtd)' : 'Montante que recebe' }}</div>
                </div>
                <div class="fee-calc-sep plus">+</div>
                <div class="fee-calc-item">
                  <div class="fee-calc-label">Comissão FundCube ({{ comissaoPorCampanha }}%)</div>
                  <div class="fee-calc-value v-commission">{{ comissao | money }} Kz</div>
                  <div class="fee-calc-sub">Gestão e liquidação</div>
                </div>
                <div class="fee-calc-sep equal">=</div>
                <div class="fee-calc-item">
                  <div class="fee-calc-label">Meta Total da Campanha</div>
                  <div class="fee-calc-value v-goal">{{ meta | money }} Kz</div>
                  <div class="fee-calc-sub">Valor visível aos apoiadores</div>
                </div>
              </div>
              <div class="fee-calc-footer">
                <i class="fa-solid fa-circle-check"></i>
                <span>Garantia de Sucesso: Os fundos são transferidos assim que atingir no mínimo <strong>{{
                    percentAprovacao }}%</strong> da meta.</span>
              </div>
            </div>

            <!-- Duração em Dias (Pills Radio & Input Direto) -->
            <div class="form-group mt-5">
              <label class="form-label">
                Duração da Campanha (Dias) <span class="required">*</span>
              </label>
              <!-- Seleção rápida por Pills -->
              <div class="duration-pills-grid">
                <div class="duration-pill" *ngFor="let d of diasList"
                  [class.selected]="+campanhaForm.get('dias')?.value === +d.key" (click)="selecionarDuracao(d.key)">
                  <div class="dp-val">{{ d.name }}</div>
                  <div class="dp-unit">dias</div>
                  <div class="dp-check" *ngIf="+campanhaForm.get('dias')?.value === +d.key">
                    <i class="fa-solid fa-check"></i>
                  </div>
                </div>
              </div>

              <!-- Input numérico direto para duração personalizada -->
              <div class="mt-3 flex items-center gap-2">
                <div class="input-with-icon" style="max-width: 260px;">
                  <i class="fa-solid fa-clock input-icon"></i>
                  <input type="number" pInputText formControlName="dias" min="1" placeholder="Ou digite os dias"
                    class="form-input" [class.error]="isInvalid('dias')" (input)="onDiasInputChange($event)" />
                </div>
                <span class="text-sm text-gray-500 font-medium">dias</span>
              </div>

              <!-- Aviso de cronograma: Campanha encerra antes do início da liberação das recompensas -->
              <div class="recompensa-dias-aviso"
                *ngIf="campanhaForm.get('tipoFinanciamentoENUM')?.value === 3 && getMenorDataInicioRecompensas()">
                <i class="fa-solid fa-calendar-check"></i>
                <div class="rda-text">
                  <span><strong>Cronograma de Liberação:</strong> As recompensas são liberadas após a campanha atingir a meta e encerrar.</span>
                  <span class="block mt-0.5 text-xs">
                    Término previsto da campanha: <strong>{{ getDataTerminoCampanha() | date: 'dd/MM/yyyy' }}</strong> (duração de <strong>{{ campanhaForm.get('dias')?.value }} dias</strong>).
                    Primeira entrega de recompensas a partir de: <strong>{{ getMenorDataInicioRecompensas() | date: 'dd/MM/yyyy' }}</strong>.
                  </span>
                </div>
              </div>
              <span class="form-hint"
                *ngIf="campanhaForm.get('tipoFinanciamentoENUM')?.value === 3 && recompensaDuracaoMinima && recompensaDuracaoMaxima">
                <i class="fa-solid fa-circle-info"></i> Para financiamento por recompensa, a plataforma estipula duração
                entre <strong>{{ recompensaDuracaoMinima }}</strong> e <strong>{{ recompensaDuracaoMaxima }}
                  dias</strong> (conforme configurado na API).
              </span>
              <span class="form-hint" *ngIf="campanhaForm.get('tipoFinanciamentoENUM')?.value !== 3">
                Prazos entre 30 e 60 dias historicamente geram 40% mais envolvimento.
              </span>
              <small class="field-error" *ngIf="isInvalid('dias')">
                <i class="fa-solid fa-triangle-exclamation"></i> A duração em dias é obrigatória.
              </small>
            </div>

            <!-- Secção Bancária: IBAN -->
            <div class="bank-section">
              <div class="bank-section-header">
                <div class="bank-section-header-icon"><i class="fa-solid fa-building-columns"></i></div>
                <div class="bank-section-header-text">
                  <div class="bank-section-title">Dados Bancários para Liquidação</div>
                  <div class="bank-section-subtitle">Conta bancária nacional em Kwanzas (AOA)</div>
                </div>

              </div>
              <div class="bank-section-body">
                <div class="bank-alert">
                  <i class="fa-solid fa-shield-halved"></i>
                  <div class="bank-alert-text">
                    Por razões de conformidade e segurança financeira, os fundos angariados serão liquidados
                    exclusivamente para a conta bancária do titular registado.
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label" for="iban">IBAN Registado</label>
                  <div class="iban-input-wrap">
                    <p-inputMask formControlName="iban" mask="AO06 9999-0000-9999999999999"
                      placeholder="AO06 0040-0000-1234567890123" [autoClear]="false" class="w-full"
                      variant="filled"></p-inputMask>
                    <i class="fa-solid fa-circle-check iban-status-icon valid"
                      *ngIf="campanhaForm.get('iban')?.value"></i>
                  </div>
                  <small class="field-error" *ngIf="isInvalid('iban')">
                    <i class="fa-solid fa-triangle-exclamation"></i> Formato de IBAN inválido.
                  </small>
                </div>
              </div>
            </div>

            <!-- Documento de Apresentação (PDF) -->
            <div class="form-group mt-5">
              <label class="form-label">
                Documento de Apresentação / Plano de Projecto (PDF) <span class="required">*</span>
              </label>
              <div class="upload-zone" [class.has-file]="selectedPdF || docPreview">
                <input id="pdf-upload" type="file" accept=".pdf" (change)="onPdFSelected($event)" />

                <div class="upload-preview-state" *ngIf="selectedPdF || docPreview">
                  <div class="ups-icon pdf"><i class="fa-solid fa-file-pdf"></i></div>
                  <div class="ups-info">
                    <div class="ups-name">{{ selectedPdF ? selectedPdF.name : (docInfo?.nome || 'Documento do Projecto')
                      }}</div>
                    <div class="ups-size">{{ selectedPdF ? ((selectedPdF.size / (1024 * 1024)) | number: '1.0-2') + '
                      MB' : (docInfo?.tamanho || '') }}</div>
                    <span class="upload-badge"><i class="fa-solid fa-check"></i> Documento anexado</span>
                  </div>
                  <button type="button" class="btn-icon danger" title="Remover PDF"
                    (click)="$event.stopPropagation(); removePdF()">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>

                <div class="upload-empty-state" *ngIf="!selectedPdF && !docPreview">
                  <div class="upload-icon"><i class="fa-solid fa-file-circle-plus"></i></div>
                  <div class="upload-text">Carregar documento de suporte (PDF)</div>
                  <div class="upload-hint">Business plan, orçamento discriminado ou ficha técnica (máx. 10MB).</div>
                </div>
              </div>
              <small class="field-error" *ngIf="isInvalid('docProjeto')">
                <i class="fa-solid fa-triangle-exclamation"></i> O documento de apresentação é obrigatório.
              </small>
            </div>

            <!-- Redes Sociais -->
            <div class="form-group mt-5" formArrayName="RedesSociaisList">
              <div class="flex items-center justify-between mb-2">
                <label class="form-label mb-0">Redes Sociais e Canais de Divulgação</label>
                <button type="button" class="btn btn-ghost btn-sm" (click)="addSocialLink()"
                  [disabled]="!canAddSocialLink()"
                  [title]="!canAddSocialLink() ? 'Preencha o canal anterior antes de adicionar outro' : 'Adicionar Canal'">
                  <i class="fa-solid fa-plus"></i> Adicionar Canal
                </button>
              </div>
              <span class="form-hint mb-3">YouTube, LinkedIn, Facebook, Instagram, X (Twitter) ou TikTok.</span>

              <div class="social-links-list">
                <div *ngFor="let control of RedesSociaisList.controls; let i = index" class="social-input-row">
                  <div class="input-with-icon flex-1">
                    <i class="fa-solid fa-share-nodes input-icon"></i>
                    <input type="url" class="form-input" pInputText [formControlName]="i"
                      placeholder="https://instagram.com/o-meu-projecto" />
                  </div>
                  <button type="button" class="btn-icon danger" title="Remover rede social"
                    (click)="removeSocialLink(i)">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Ficheiros já existentes em Modo de Edição -->
            <div class="existing-files-box mt-4" *ngIf="IsEditMode && (imgPreview || docPreview)">
              <h5 class="efb-title"><i class="fa-solid fa-paperclip"></i> Anexos Guardados no Rascunho</h5>
              <div class="efb-grid">
                <div class="efb-item" *ngIf="docPreview && docInfo" (click)="openFile($event, docPreview)">
                  <i class="fa-solid fa-file-pdf efb-icon pdf"></i>
                  <div class="efb-info">
                    <span class="efb-name">{{ docInfo.nome }}</span>
                    <span class="efb-meta">{{ docInfo.tamanho }} &bull; {{ docInfo.tipo }}</span>
                  </div>
                  <button type="button" class="btn-icon danger"
                    (click)="$event.stopPropagation(); removeAnexoCampanha(1)" title="Remover">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>

                <div class="efb-item" *ngIf="imgPreview && imgInfo" (click)="openFile($event, imgPreview)">
                  <i class="fa-solid fa-image efb-icon img"></i>
                  <div class="efb-info">
                    <span class="efb-name">{{ imgInfo.nome }}</span>
                    <span class="efb-meta">{{ imgInfo.tamanho }} &bull; {{ imgInfo.tipo }}</span>
                  </div>
                  <button type="button" class="btn-icon danger"
                    (click)="$event.stopPropagation(); removeAnexoCampanha(2)" title="Remover">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ═══════════════════════════════════════
           ALERTA / SMS DE PROGRESSO E VALIDAÇÃO (PASSO 3)
      ═══════════════════════════════════════ -->
      <div class="form-completion-alert" *ngIf="IsSave" [class.complete]="isFormularioCompleto()">
        <div class="fca-icon">
          <i class="fa-solid" [ngClass]="isFormularioCompleto() ? 'fa-circle-check' : 'fa-triangle-exclamation'"></i>
        </div>
        <div class="fca-content">
          <div class="fca-header-row">
            <h4 class="fca-title">
              {{ isFormularioCompleto() ? 'Formulário Completo e Pronto a Publicar!' : 'Preenchimento do Formulário: ' +
              getPercentualPreenchimento() + '%' }}
            </h4>
            <span class="fca-badge" [class.complete]="isFormularioCompleto()">
              {{ isFormularioCompleto() ? '100% Concluído' : (getCamposPendentes().length + ' Pendente(s)') }}
            </span>
          </div>

          <div class="fca-progress-track">
            <div class="fca-progress-bar" [style.width.%]="getPercentualPreenchimento()"
              [class.complete]="isFormularioCompleto()"></div>
          </div>

          <p class="fca-message" *ngIf="!isFormularioCompleto()">
            O botão <strong>{{ IsEditMode ? 'Atualizar e Publicar' : 'Publicar Campanha' }}</strong> só ficará ativo
            após o preenchimento de todos os requisitos obrigatórios. Clique num item pendente para ir diretamente ao
            campo:
          </p>

          <p class="fca-message complete" *ngIf="isFormularioCompleto()">
            Todos os requisitos obrigatórios foram validados com sucesso. Pode agora publicar a sua campanha!
          </p>

          <div class="fca-pending-grid" *ngIf="!isFormularioCompleto() && getCamposPendentes().length > 0">
            <button type="button" class="fca-pending-chip" *ngFor="let p of getCamposPendentes()"
              (click)="focarCampoPendente(p)">
              <span class="chip-step">Passo {{ p.step }}</span>
              <span class="chip-label">{{ p.label }}</span>
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════
           BARRA DE NAVEGAÇÃO ENTRE PASSOS
      ═══════════════════════════════════════ -->
      <div class="step-nav-footer">
        <button type="button" pButton class="btn btn-ghost" (click)="Isreturn ? toHome() : returntep()"
          severity="secondary">
          <i class="fa-solid" [ngClass]="Isreturn ? 'fa-xmark' : 'fa-arrow-left'"></i>
          {{ Isreturn ? 'Cancelar' : 'Voltar' }}
        </button>

        <div class="step-nav-actions">
          <!-- Guardar Rascunho -->
          <button type="button" class="btn btn-outline" (click)="IsEditMode ? updateCampanha(1) : saveCampanha(1)"
            [disabled]="loadingdraft || !isFormularioCompleto()"
            [title]="!isFormularioCompleto() ? 'O formulário deve estar 100% preenchido para guardar o rascunho' : labelDraft">
            <i class="fa-solid fa-floppy-disk" *ngIf="!loadingdraft"></i>
            <i class="fa-solid fa-spinner fa-spin" *ngIf="loadingdraft"></i>
            {{ labelDraft }}
          </button>

          <!-- Pré-visualizar -->
          <!-- <button type="button" class="btn btn-ghost" (click)="gerarPreview(campanhaForm.value)">
            <i class="fa-solid fa-eye"></i> Pré-visualizar
          </button> -->

          <!-- Continuar -->
          <button type="button" class="btn btn-primary" (click)="advanceStep()" *ngIf="!IsSave">
            Continuar <i class="fa-solid fa-arrow-right"></i>
          </button>

          <!-- Criar / Publicar Campanha (Novo) -->
          <button type="button" class="btn btn-primary" (click)="saveCampanha(2)" *ngIf="IsSave && !IsEditMode"
            [disabled]="loading || !isFormularioCompleto()"
            [title]="!isFormularioCompleto() ? 'Preencha todos os campos obrigatórios para publicar a campanha' : 'Publicar Campanha'">
            <i class="fa-solid fa-rocket" *ngIf="!loading"></i>
            <i class="fa-solid fa-spinner fa-spin" *ngIf="loading"></i>
            {{ loading ? 'A submeter...' : 'Publicar Campanha' }}
          </button>

          <!-- Atualizar Campanha (Edição) -->
          <button type="button" class="btn btn-primary" (click)="updateCampanha(2)" *ngIf="IsSave && IsEditMode"
            [disabled]="loading || !isFormularioCompleto()"
            [title]="!isFormularioCompleto() ? 'Preencha todos os campos obrigatórios para publicar a campanha' : 'Atualizar e Publicar'">
            <i class="fa-solid fa-rocket" *ngIf="!loading"></i>
            <i class="fa-solid fa-spinner fa-spin" *ngIf="loading"></i>
            {{ loading ? 'A atualizar...' : 'Atualizar e Publicar' }}
          </button>
        </div>
      </div>
    </form>
  </main>

  <!-- ════════════════ ASIDE PREVIEW & TIPS ════════════════ -->
  <aside class="wizard-aside">
    <div class="preview-sticky">

      <!-- Live Campaign Card Preview -->
      <div class="preview-card">
        <div class="preview-card-header">
          <span class="preview-live"></span>
          <span class="preview-label">Pré-visualização em Directo</span>
        </div>
        <div class="preview-body">
          <!-- Imagem de Capa -->
          <div class="preview-img-wrap">
            <img *ngIf="selectedFilePreviewUrl || imgPreview" [src]="selectedFilePreviewUrl || imgPreview"
              alt="Capa da Campanha" />
            <div class="preview-img-placeholder" *ngIf="!selectedFilePreviewUrl && !imgPreview">
              <i class="fa-solid fa-cube"></i>
            </div>
            <!-- Type badge -->
            <span class="preview-type-badge" [ngClass]="{
              'ptb-doacao': campanhaForm.get('tipoFinanciamentoENUM')?.value === 1,
              'ptb-emprestimo': campanhaForm.get('tipoFinanciamentoENUM')?.value === 2,
              'ptb-recompensa': campanhaForm.get('tipoFinanciamentoENUM')?.value === 3
            }">
              {{ campanhaForm.get('tipoFinanciamentoENUM')?.value === 1 ? 'Doação' :
              campanhaForm.get('tipoFinanciamentoENUM')?.value === 2 ? 'Empréstimo' : 'Recompensa' }}
            </span>
          </div>

          <div class="preview-category-row">
            <span class="preview-cat">{{ getCategoriaDesc(campanhaForm.get('CategoriaID')?.value) }}</span>
            <span class="preview-loc"><i class="fa-solid fa-location-dot"></i> {{
              getProvinciaDesc(campanhaForm.get('ProvinciaID')?.value) }}</span>
          </div>

          <h4 class="preview-title">
            {{ campanhaForm.get('titulo')?.value || 'Título da sua campanha aparecerá aqui...' }}
          </h4>

          <!-- Barra de Progresso Simulado -->
          <div class="preview-bar-wrap">
            <div class="preview-bar">
              <div class="preview-fill" style="width: 0%"></div>
            </div>
            <div class="preview-meta">
              <span><strong>0 Kz</strong> angariados</span>
              <span>Meta: <strong>{{ (meta || (campanhaForm.get('MetaArrecadar')?.value || 0)) | money }}
                  Kz</strong></span>
            </div>
          </div>

          <div class="preview-footer-row">
            <span class="preview-days">
              <i class="fa-regular fa-clock"></i>
              {{ campanhaForm.get('dias')?.value ? (campanhaForm.get('dias')?.value + ' dias') : 'Duração a definir' }}
            </span>
            <span class="preview-author" *ngIf="userdata?.nome">
              <i class="fa-regular fa-user"></i> {{ userdata?.nome }}
            </span>
          </div>
        </div>
      </div>

      <!-- Card de Progresso e Validação Geral -->
      <div class="form-status-card" [class.complete]="isFormularioCompleto()">
        <div class="fsc-header">
          <div class="fsc-icon">
            <i class="fa-solid" [ngClass]="isFormularioCompleto() ? 'fa-circle-check' : 'fa-chart-pie'"></i>
          </div>
          <div>
            <h5 class="fsc-title">Nível de Preenchimento</h5>
            <span class="fsc-subtitle">
              {{ isFormularioCompleto() ? 'Formulário 100% completo' : (getCamposPendentes().length + ' campo(s)
              pendente(s)') }}
            </span>
          </div>
          <span class="fsc-pct-pill" [class.complete]="isFormularioCompleto()">
            {{ getPercentualPreenchimento() }}%
          </span>
        </div>

        <div class="fsc-progress-wrap">
          <div class="fsc-progress-bar">
            <div class="fsc-progress-fill" [style.width.%]="getPercentualPreenchimento()"
              [class.complete]="isFormularioCompleto()"></div>
          </div>
        </div>

        <div class="fsc-message" *ngIf="!isFormularioCompleto()">
          <p class="fsc-msg-text">
            <i class="fa-solid fa-circle-info"></i>
            O botão <strong>Publicar Campanha</strong> só será ativado quando todos os campos obrigatórios forem
            preenchidos.
          </p>
        </div>

        <div class="fsc-message complete" *ngIf="isFormularioCompleto()">
          <p class="fsc-msg-text">
            <i class="fa-solid fa-circle-check"></i>
            Todos os requisitos foram preenchidos! Pode publicar a sua campanha com segurança.
          </p>
        </div>

        <div class="fsc-pending-list" *ngIf="!isFormularioCompleto() && getCamposPendentes().length > 0">
          <span class="fsc-pending-label">Clique para preencher:</span>
          <div class="fsc-pending-items">
            <button type="button" class="fsc-pending-item" *ngFor="let campo of getCamposPendentes()"
              (click)="focarCampoPendente(campo)">
              <span class="fsc-pi-step">Passo {{ campo.step }}</span>
              <span class="fsc-pi-name">{{ campo.label }}</span>
              <i class="fa-solid fa-chevron-right fsc-pi-arrow"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Dicas Contextuais por Passo -->
      <div class="tips-card">
        <div class="tips-header">
          <i class="fa-solid fa-lightbulb tips-icon"></i>
          <span class="tips-title">Dicas para o Passo {{ step }}</span>
        </div>
        <div class="tips-list" *ngIf="step === 1">
          <div class="tip-item">
            <i class="fa-solid fa-check"></i>
            <span><strong>Modelo claro:</strong> Projectos sociais têm melhor taxa de sucesso na modalidade de
              Doação.</span>
          </div>
          <div class="tip-item">
            <i class="fa-solid fa-check"></i>
            <span><strong>Categorização:</strong> A categoria correcta ajuda os investidores e apoiadores a encontrarem
              a sua iniciativa.</span>
          </div>
        </div>
        <div class="tips-list" *ngIf="step === 2">
          <div class="tip-item">
            <i class="fa-solid fa-check"></i>
            <span><strong>Imagem de impacto:</strong> Campanhas com fotos reais do terreno recebem até 3x mais
              contribuições.</span>
          </div>
          <div class="tip-item">
            <i class="fa-solid fa-check"></i>
            <span><strong>Vídeo autêntico:</strong> Um vídeo curto gravado pelo criador transmite enorme
              credibilidade.</span>
          </div>
        </div>
        <div class="tips-list" *ngIf="step === 3">
          <div class="tip-item">
            <i class="fa-solid fa-check"></i>
            <span><strong>Meta realista:</strong> Calcule o orçamento detalhado incluindo a taxa FundCube para assegurar
              o valor líquido desejado.</span>
          </div>
          <div class="tip-item">
            <i class="fa-solid fa-check"></i>
            <span><strong>Segurança:</strong> O IBAN validado garante transferências directas e seguras após o fecho da
              campanha.</span>
          </div>
        </div>
      </div>

    </div>
  </aside>
</div>

<!-- ════════════════ MODAL DE PRÉ-VISUALIZAÇÃO COMPLETA ════════════════ -->
<p-dialog header="Pré-visualização da Campanha" [(visible)]="ShowPreview" [modal]="true" appendTo="body"
  [style]="{ width: '92vw', 'max-width': '46rem' }">
  <div class="preview-modal-content">
    <div class="pm-header-card">
      <span class="badge badge-green" *ngIf="campanhaPreview?.tipoFinanciamentoENUM === 1">Doação</span>
      <span class="badge badge-blue" *ngIf="campanhaPreview?.tipoFinanciamentoENUM === 2">Empréstimo</span>
      <span class="badge badge-amber" *ngIf="campanhaPreview?.tipoFinanciamentoENUM === 3">Recompensa</span>
      <h3 class="pm-title mt-2">{{ campanhaPreview?.titulo || 'Título não definido' }}</h3>
      <p class="pm-lead">{{ campanhaPreview?.descricaoCurta }}</p>
    </div>

    <div class="pm-meta-grid">
      <div class="pm-meta-item">
        <span class="pm-label">Meta de Angariação</span>
        <span class="pm-val">{{ campanhaPreview?.metaArrecadar | money }} Kz</span>
      </div>
      <div class="pm-meta-item">
        <span class="pm-label">Duração</span>
        <span class="pm-val">{{ campanhaPreview?.dias }} dias</span>
      </div>
      <div class="pm-meta-item" *ngIf="campanhaPreview?.linkVideo">
        <span class="pm-label">Vídeo</span>
        <a [href]="campanhaPreview?.linkVideo" target="_blank" class="pm-val link">Ver Vídeo <i
            class="fa-solid fa-arrow-up-right-from-square"></i></a>
      </div>
    </div>

    <!-- Recompensas se existirem -->
    <div class="pm-section" *ngIf="recompensas.length > 0">
      <h4 class="pm-section-title"><i class="fa-solid fa-gift"></i> Recompensas Oferecidas</h4>
      <div class="recompensa-item-card mb-2" *ngFor="let r of recompensas.controls; let i = index">
        <div class="ric-left">
          <span class="ric-badge">#{{ i + 1 }}</span>
          <div>
            <div class="ric-title">{{ r.value.Titulo }}</div>
            <div class="ric-meta">{{ r.value.Valor | money }} Kz &bull; Qtd: {{ r.value.Quantidade }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Ficheiros anexados -->
    <div class="pm-section" *ngIf="campanhaPreviewIMG || campanhaPreviewPDF || imgInfo || docInfo">
      <h4 class="pm-section-title"><i class="fa-solid fa-paperclip"></i> Documentos & Anexos</h4>
      <div class="flex gap-2 flex-wrap">
        <span class="badge badge-gray" *ngIf="campanhaPreviewIMG || imgInfo"><i class="fa-solid fa-image"></i> Imagem de
          Capa</span>
        <span class="badge badge-gray" *ngIf="campanhaPreviewPDF || docInfo"><i class="fa-solid fa-file-pdf"></i>
          Documento PDF</span>
        <span class="badge badge-gray" *ngIf="campanhaPreviewVID || VidInfo"><i class="fa-solid fa-film"></i> Ficheiro
          de Vídeo</span>
      </div>
    </div>
  </div>
</p-dialog>